import { render } from "./SamplingPointConfig.view.vue?vue&type=template&id=72907868&scoped=true&ts=true"
import script from "./SamplingPointConfig.view.vue?vue&type=script&lang=ts"
export * from "./SamplingPointConfig.view.vue?vue&type=script&lang=ts"

import "./SamplingPointConfig.view.vue?vue&type=style&index=0&id=72907868&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72907868"]])

export default __exports__